import React from "react";
import { Button, Input, Label, Dropdown, Option } from "@fluentui/react-components";
import { Add20Regular, Delete20Regular, Edit20Regular } from "@fluentui/react-icons";
import { useTranslation } from "react-i18next";
import "../../CSS/RoutingChatComponents.css";

export default function FormChatComponent({ routing, updateRouting, chatFlowData }) {
  const { t } = useTranslation();

  const { routingName, ...routingData } = routing;
  const items = routingData.items || [];
  const next = routingData.next || {};

  const updateField = (field, value) => {
    updateRouting({ 
      ...routingData,
      [field]: value 
    });
  };

  const addFormItem = () => {
    const newItem = {
      id: `field_${Date.now()}`,
      placeholder: "",
      type: "Input.Text"
    };
    updateField("items", [...items, newItem]);
  };

  const updateFormItem = (index, field, value) => {
    const updatedItems = [...items];
    updatedItems[index] = {
      ...updatedItems[index],
      [field]: value
    };
    updateField("items", updatedItems);
  };

  const deleteFormItem = (index) => {
    const updatedItems = items.filter((_, i) => i !== index);
    updateField("items", updatedItems);
  };

  const updateNext = (nextType, nextValue) => {
    if (!nextType || !nextValue) {
      updateField("next", {});
    } else {
      updateField("next", {
        type: nextType,
        routingName: nextValue
      });
    }
  };

  const getAvailableRoutings = () => {
    return Object.keys(chatFlowData.routing || {}).filter(key => key !== routing.routingName);
  };

  const getRoutingDisplayName = (routingKey) => {
    if (routingKey === "0") return "START";
    const routingObj = chatFlowData.routing?.[routingKey];
    if (!routingObj) return routingKey;
    
    // Retourner displayName s'il existe, sinon le routingKey
    return routingObj.displayName || routingKey;
  };

  return (
    <div className="routing-chat-container">
      <div className="routing-field">
        <Label>Routing type</Label>
        <Input
          value={routingData.type || "form"}
          disabled
          readOnly
        />
      </div>

      <div className="routing-grid-container">
        {/* Header */}
        <div className="routing-grid-header form-grid-header">
          <span>Label</span>
          <span>Placeholder</span>
          <span>Type</span>
          <span>Action</span>
        </div>

        {/* Rows */}
        {items.map((item, index) => (
          <div key={index} className="routing-grid-row form-grid-row">
            <div className="routing-grid-cell">
              <Input
                value={item.id || ""}
                onChange={(e) => updateFormItem(index, "id", e.target.value)}
                placeholder="Enter label"
              />
            </div>
            
            <div className="routing-grid-cell">
              <Input
                value={item.placeholder || ""}
                onChange={(e) => updateFormItem(index, "placeholder", e.target.value)}
                placeholder="Enter placeholder"
              />
            </div>
            
            <div className="routing-grid-cell">
              <Dropdown
                value={item.type || "Input.Text"}
                selectedOptions={[item.type || "Input.Text"]}
                onOptionSelect={(_, data) => {
                  updateFormItem(index, "type", data.optionValue);
                }}
              >
                <Option value="Input.Text">Text</Option>
                <Option value="Input.Number">Number</Option>
                <Option value="Input.Date">Date</Option>
                <Option value="Input.Time">Time</Option>
                <Option value="Input.Email">Email</Option>
                <Option value="Input.Tel">Phone</Option>
              </Dropdown>
            </div>
            
            <Button
              icon={<Delete20Regular />}
              appearance="subtle"
              onClick={() => deleteFormItem(index)}
            />
          </div>
        ))}
        
        {/* Add new input button */}
        <div className="routing-grid-add-row">
          <Button icon={<Add20Regular />} appearance="subtle" onClick={addFormItem}>
          </Button>
        </div>
      </div>

      <div className="next-step-section">
        <Label className="next-step-header">Next</Label>
        
        <div className="next-step-field">
          <Dropdown
            value={getRoutingDisplayName(next.routingName) || ""}
            selectedOptions={next.routingName ? [next.routingName] : []}
            onOptionSelect={(_, data) => {
              const selectedRoutingName = data.optionValue;
              if (!selectedRoutingName || selectedRoutingName === "") {
                updateField("next", {});
              } else {
                const selectedRoutingObj = chatFlowData.routing?.[selectedRoutingName];
                const routingType = selectedRoutingObj?.type;
                
                let nextType;
                if (routingType === "Customer Choice" || routingType === "customer choice" || routingType === "customerChoice") {
                  nextType = "customerChoice";
                } else if (routingType === "Form" || routingType === "form") {
                  nextType = "form";
                } else if (routingType === "Queue" || routingType === "queue") {
                  nextType = "queue";
                } else {
                  nextType = routingType || "routing";
                }
                
                updateField("next", { 
                  type: nextType,
                  routingName: selectedRoutingName 
                });
              }
            }}
            placeholder="Select routing"
          >
            <Option value="" text="None">None</Option>
            {getAvailableRoutings().map(routingKey => (
              <Option key={routingKey} value={routingKey} text={getRoutingDisplayName(routingKey)}>
                {getRoutingDisplayName(routingKey)}
              </Option>
            ))}
          </Dropdown>
        </div>
      </div>

      
    </div>
  );
}
